import { useState } from 'react';
import { Info } from 'lucide-react';

interface ConfidenceBadgeProps {
  score: number;
  rationale?: string;
}

export function ConfidenceBadge({ score, rationale }: ConfidenceBadgeProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  const percentage = Math.round(score * 100);

  // Color based on confidence level
  let colorClass = 'bg-green-500/20 text-green-600 dark:text-green-400';
  let label = 'High';
  if (score < 0.3) {
    colorClass = 'bg-red-500/20 text-red-600 dark:text-red-400';
    label = 'Low';
  } else if (score < 0.7) {
    colorClass = 'bg-yellow-500/20 text-yellow-600 dark:text-yellow-400';
    label = 'Medium';
  }

  return (
    <div className="relative inline-flex items-center">
      <button
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${colorClass}`}
      >
        <Info className="h-3 w-3" />
        {percentage}% {label}
      </button>
      {showTooltip && rationale && (
        <div className="absolute bottom-full left-0 mb-2 w-64 rounded-md bg-popover p-2 text-xs text-popover-foreground shadow-lg border border-border z-10">
          {rationale}
        </div>
      )}
    </div>
  );
}
